queryMatches = (first, second) ->
  first.toLowerCase().indexOf( second.toLowerCase().trim() ) != -1

App.CommunicationChannelsEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')
  needs: [ 'communicationChannels', 'communicationChannelsIndex' ]

  channelBinding: 'model'

  toggleText: (->
    Em.I18n.t "communication_channels.edit.enabled.#{@get('channel.enabled')}"
  ).property('channel.enabled')


  actions:
    cancel: ->
      channel = @get('channel')

      if channel.get('isDirty')
        return unless confirm 'Отменить изменения?'
        channel = @get('channel')
        channel.rollback()

      @send('goBackToChannelsList')

      false
    save: ->
      channel = @get('channel')
      @set('isLoading', true)
      channel.save()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('communication-channels')
      false
